import { Employee } from "../../process/types/processTypes";
import { Company } from "../../setups/types/setupTypes";

export enum WallCategory {
  General = "General",
  CandidateContact = "CandidateContact",
  BrokerContact = "BrokerContact",
  FamilyContact = "FamilyContact",
  Document = "Document",
  Visa = "Visa",
  Medical = "Medical",
  ProcessUpdate = "ProcessUpdate",
  Announcement = "Announcement",
  Issue = "Issue",
  ComplaintFollowUp = "ComplaintFollowUp",
}

export type WallComplaintRef = {
  _id?: string;
  subject?: string;
  status?: string;
};

export type WallUser = {
  _id?: string;
  name?: string;
  avatar?: string;
  email?: string;
};

export type BrokerRef = {
  company?: Company;
  name?: string;
};

export type ContactRef = {
  name: string;
  employee?: Employee;
};

export type WallReaction = {
  user?: WallUser;
  type: string;
};

export type WallAttachment = {
  url: string;
  name?: string;
  contentType?: string;
};

export type WallComment = {
  _id?: string;
  author?: WallUser;
  message: string;
  audioUrl?: string;
  attachments?: WallAttachment[];
  mentions?: WallUser[];
  createdAt?: Date;
  editedAt?: Date;
};

export type WallPost = {
  _id?: string;
  author?: WallUser;
  message: string;
  audioUrl?: string;
  attachments?: WallAttachment[];
  category: WallCategory;
  tags?: string[];
  employees?: Employee[];
  brokers?: BrokerRef[];
  contacts?: ContactRef[];
  mentions?: WallUser[];
  comments?: WallComment[];
  reactions?: WallReaction[];
  complaint?: WallComplaintRef;
  pinned?: boolean;
  pinnedAt?: Date;
  editedAt?: Date;
  createdAt?: Date;
};

export type WallPostsWithCount = {
  totalCount: number;
  posts: WallPost[];
};

export type WallFeedFilters = {
  skip: number;
  take: number;
  category?: WallCategory;
  employeeId?: string;
  brokerCompanyId?: string;
  authorId?: string;
  mentionId?: string;
  tag?: string;
  searchText?: string;
  complaintId?: string;
  append?: boolean;
};

export type BrokerInput = {
  companyId?: string;
  name?: string;
};

export type ContactInput = {
  name: string;
  employeeId?: string;
};

export type WallPostInput = {
  id?: string;
  message: string;
  audioUrl?: string;
  attachments?: WallAttachment[];
  category: WallCategory;
  tags?: string[];
  employeeIds?: string[];
  brokers?: BrokerInput[];
  contacts?: ContactInput[];
  mentionIds?: string[];
  complaintId?: string;
};

export type WallState = {
  posts: WallPost[];
  totalCount: number;
  loading: "idle" | "pending";
  error: { message: string } | null;
  success: { message: string } | null;
};
